import { z } from 'zod'

import DEFAULT_PAGE_SIZE from '@/constants/default-page-size'
import { labelAndValue, requiredString } from '@/utils/zod'

export const coursesManagementFiltersSchema = z.object({
  ids: z.array(labelAndValue()).optional(),
  educationLevelIds: z.array(requiredString()).optional(),
  domainIds: z.array(labelAndValue()).optional(),
  preferredRoomIds: z.array(labelAndValue()).optional(),
  page: z.number().catch(1),
  pageSize: z.number().catch(DEFAULT_PAGE_SIZE)
})

export type CoursesManagementFilters = z.infer<
  typeof coursesManagementFiltersSchema
>

export type CoursesManagementFiltersKey = keyof CoursesManagementFilters
